var map = {
	"./de/triangle-icon.png": "i0yA",
	"./en/triangle-icon.png": "B/Mm",
	"./es/triangle-icon.png": "i/5h",
	"./fr/triangle-icon.png": "rM19",
	"./ja/triangle-icon.png": "iuBn",
	"./ko/triangle-icon.png": "Co+J",
	"./pt/triangle-icon.png": "psVx",
	"./ru/triangle-icon.png": "yugM",
	"./tc/triangle-icon.png": "iMXA",
	"./th/triangle-icon.png": "NZra"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3O+e";